import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const JsFileIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "JsFile",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M29.53 10.55a2 2 0 0 0-.12-.35s0-.07 0-.07c-.06-.11-.14-.21-.22-.3l-7.53-7.5c-.09-.09-.19-.16-.3-.22s-.08 0-.08 0c-.08-.04-.17-.08-.27-.11s-9.67 0-9.67 0a4.21 4.21 0 0 0-4.21 4.15v7.95H4.32c-1.03 0-1.87.84-1.87 1.87v6.55c0 1.03.84 1.87 1.87 1.87h2.81v1.87c0 2.2 1.73 3.74 4.21 3.74h14.02c2.47 0 4.21-1.54 4.21-3.74V10.55h-.02ZM17.4 16.4c0 .26-.21.47-.47.47h-2.31v1.87h2.34c.26 0 .47.21.47.47v2.81c0 .26-.21.47-.47.47h-2.84a.49.49 0 0 1 0-.98h2.34v-1.79h-2.34a.47.47 0 0 1-.47-.47v-2.81c0-.26.21-.47.47-.47h2.81c.26 0 .47.21.47.47zm-5.61 0v5.61c0 .26-.21.47-.47.47H8.51a.47.47 0 0 1-.47-.47v-2.77a.49.49 0 0 1 .98 0v2.34h1.83v-5.14a.49.49 0 0 1 .98 0zm14.95 9.86c0 .77-.76.97-1.4.97H11.32c-.64 0-1.4-.17-1.4-.97v-1.87h11.22c1.03 0 1.87-.84 1.87-1.87v-6.55c0-1.03-.84-1.87-1.87-1.87H9.92V6.15c0-.77.63-1.4 1.4-1.4h7.95v5.14c0 1.29 1.05 2.34 2.34 2.34h5.14v14.03Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M17.21 26.77v-1.76c.3.12.6.2.9.2.5 0 .87-.26.87-.96v-4.98h1.95v5.3c0 1.52-1.02 2.43-2.51 2.43-.33 0-.86-.07-1.21-.23M21.84 26.26v-1.88c.79.6 1.73.93 2.54.93.7 0 1.14-.24 1.14-.64 0-.29-.2-.51-.71-.65l-1.22-.35c-1.15-.33-1.81-1.01-1.81-2.1 0-1.4 1.23-2.4 2.87-2.4.94 0 1.62.2 2.33.58v1.84c-.88-.5-1.65-.71-2.25-.71s-.97.22-.97.57c0 .26.2.46.56.57l1.08.32c1.23.36 2.09 1 2.09 2.31 0 1.41-1.21 2.37-3 2.37-.97 0-1.92-.26-2.64-.74Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M14 27H6c-1.65 0-3-1.35-3-3V6c0-1.65 1.35-3 3-3h12c.27 0 .52.11.71.29l8 8a.996.996 0 1 1-1.41 1.41l-7.71-7.71H6c-.55 0-1 .45-1 1v18c0 .55.45 1 1 1h8c.55 0 1 .45 1 1s-.45 1-1 1Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M26 17c-.55 0-1-.45-1-1v-3h-5c-1.65 0-3-1.35-3-3V4c0-.55.45-1 1-1s1 .45 1 1v6c0 .55.45 1 1 1h6c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1"
      })]
    })
  }));
};
JsFileIcon.displayName = 'JsFileIcon';